var a=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;var r=function(r){return a.test(r)};export{r as _};
//# sourceMappingURL=_hasUnicodeWord.js.map
